import { render, staticRenderFns } from "./FeaturesField.vue?vue&type=template&id=b2c2410c&scoped=true&"
import script from "./FeaturesField.vue?vue&type=script&lang=js&"
export * from "./FeaturesField.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesField.vue?vue&type=style&index=0&id=b2c2410c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2410c",
  null
  
)

export default component.exports